import React from "react";

export class Modal extends React.Component {
  render() {
    if (!this.props.show){
      return null;
    }

    return <div className="modal-custom">
      <div className="modal-content">
        <div className="modal-header">
          {
            this.props.onClose && <button type="button" className="close" onClick={this.props.onClose}>
              <span aria-hidden="true">×</span>
            </button>
          }
          <h3 className="modal-title">{this.props.title}</h3>
        </div>
        <div className="modal-body">
          {this.props.children}
        </div>

        {
          this.props.footer && <div className="modal-footer">
            {this.props.footer}
          </div>
        }
      </div>
    </div>;
  }
}
